import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class OutsourcedSpecificationService extends Service {
	constructor(injector: Injector) {
		super("OutsourcedSpecification", injector);
	}

	// API
	getByClientId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByClientId/${id}`);
	}
}